import * as React from 'react';
import styled from 'styled-components';
import { marked } from 'marked';
import * as DOMPurifyModule from 'dompurify';

// O dompurify e distribuido como CommonJS e o projeto nao liga esModuleInterop.
const DOMPurify = (DOMPurifyModule as any).default || DOMPurifyModule;

export interface MarkdownViewProps {
  source?: string | null;
  className?: string;
}

const Rendered = styled.div`
  p,
  ul,
  ol,
  blockquote,
  h3,
  h4 {
    margin: 0 0 8px;
  }

  p:last-child,
  ul:last-child,
  ol:last-child {
    margin-bottom: 0;
  }

  ul,
  ol {
    padding-left: 20px;
  }

  ul {
    list-style: disc outside;
  }

  ol {
    list-style: decimal outside;
  }

  li {
    list-style: inherit;
  }

  blockquote {
    padding-left: 10px;
    border-left: 3px solid rgba(128, 128, 128, 0.5);
    opacity: 0.85;
  }

  a {
    text-decoration: underline;
  }
`;

const toSafeHtml = (source: string) =>
  DOMPurify.sanitize(marked.parse(source, { async: false, breaks: true }) as string, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'b', 'i', 'u', 's', 'del', 'ul', 'ol', 'li',
                   'h3', 'h4', 'h5', 'h6', 'blockquote', 'code', 'pre', 'a', 'hr'],
    ALLOWED_ATTR: ['href', 'title'],
  });

const MarkdownView = ({ source, className }: MarkdownViewProps) => {
  const html = React.useMemo(() => (source ? toSafeHtml(source) : ''), [source]);

  if (!html) return null;

  return <Rendered className={className} dangerouslySetInnerHTML={{ __html: html }} />;
};

MarkdownView.displayName = 'MarkdownView';

export { MarkdownView };
